import React, { useState } from 'react'
import { Dialog } from '@alifd/next'
import styles from './index.module.scss'
import { 
  dataShare,
  literatureQuery,
  projectManage,
  qcSystem,
  trainingCourse,
  dataCollection,
  dataConversion,
  onlineStatistics,
  methodology,
  dataBoard,
  ethicalApproval,
  metadata,
  predictionModel,
  unusedMethodology,
  edit,
  add,
  remove
} from 'portal/assets/images'


interface ApplicationProps {
  imageLogo: string,
  studyName: string,
  link?: string,
}

export default function MyApplication() {
  // 编辑的弹框
  const [visible, setVisible] = useState(false)
  function onOpen() {
    setVisible(true)
  }
  function onClose() {
    setVisible(false)
  }

  const application: ApplicationProps[] = [
    {
      imageLogo: dataShare,
      studyName: '数据共享',
      link: '/apps/dsp?path=/studies',
    },
    {
      imageLogo: literatureQuery,
      studyName: '文献查询',
      link: '/apps/sdss',
    },
    {
      imageLogo: projectManage,
      studyName: '项目管理',
      link: '/apps/pm?path=/index.jsp?sysId=i',
    },
    {
      imageLogo: qcSystem,
      studyName: '质控系统',
      link: '/apps/qc',
    },
    {
      imageLogo: trainingCourse,
      studyName: '培训课程',
      link: '/apps/edu',
    },
    {
      imageLogo: unusedMethodology,
      studyName: '方法学门诊',
      link: 'https://ncrcrd.einmatrix.com/%E4%B8%AD%E5%BF%83%E4%BB%8B%E7%BB%8D/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/%E6%96%B9%E6%B3%95%E5%AD%A6%E9%97%A8%E8%AF%8A/',
    }
  ]

  function myApplication(props: ApplicationProps) {
    const { imageLogo, studyName, link } = props
    return (
      <ul>
        <a href={ link } target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <li style={{ marginTop: 20 }}><img src={ imageLogo } alt=""/></li>
          <li style={{ color: '#202d4c', fontSize: 16 }}>{ studyName }</li>
        </a>
      </ul>
    )
  }
  // 编辑我的应用
  const editMyApplication: ApplicationProps[] = [
    {
      imageLogo: dataShare,
      studyName: '数据共享',
    },
    {
      imageLogo: literatureQuery,
      studyName: '文献查询',
    },
    {
      imageLogo: projectManage,
      studyName: '项目管理',
    },
    {
      imageLogo: qcSystem,
      studyName: '质控系统',
    },
    {
      imageLogo: trainingCourse,
      studyName: '培训课程',
    },
    {
      imageLogo: dataCollection,
      studyName: '数据采集',
    },
    {
      imageLogo: dataConversion,
      studyName: '数据转换',
    },
    {
      imageLogo: onlineStatistics,
      studyName: '在线统计',
    },
    {
      imageLogo: methodology,
      studyName: '方法学门诊',
    }
  ]
  // 编辑全部应用
  const editAllApplication: ApplicationProps[] = [
    {
      imageLogo: dataShare,
      studyName: '数据共享',
    },
    {
      imageLogo: literatureQuery,
      studyName: '文献查询',
    },
    {
      imageLogo: projectManage,
      studyName: '项目管理',
    },
    {
      imageLogo: qcSystem,
      studyName: '质控系统',
    },
    {
      imageLogo: trainingCourse,
      studyName: '培训课程',
    },
    {
      imageLogo: dataCollection,
      studyName: '数据采集',
    },
    {
      imageLogo: predictionModel,
      studyName: '预测模型',
    },
    {
      imageLogo: dataBoard,
      studyName: '数据看板',
    },
    {
      imageLogo: metadata,
      studyName: '数据元管理',
    },
    {
      imageLogo: ethicalApproval,
      studyName: '伦理审批',
    }
  ]
  function editApplication(props: ApplicationProps) {
    const { imageLogo, studyName } = props
    return (
      <ul style={{ margin: '0 40px', position: 'relative' }}>
        <li style={{ marginTop: 20, textAlign: 'center' }}>
          <img src={ imageLogo } alt="" style={{ width: 44, height: 44 }} />
        </li>
        <li style={{ color: '#202d4c', fontSize: 16 }}>{ studyName }</li>
        <img src={ remove } alt="删除" onClick={() => { alert('删除当前项目') }} style={{ position: 'absolute', top: 10, right: -10, cursor: 'pointer' }} />
      </ul>
    )
  }

  function allApplication(props: ApplicationProps) {
    const { imageLogo, studyName } = props
    return (
      <ul style={{ margin: '0 40px', position: 'relative' }}>
        <li style={{ marginTop: 20, textAlign: 'center' }}>
          <img src={ imageLogo } alt="" style={{ width: 44, height: 44 }} />
        </li>
        <li style={{ color: '#202d4c', fontSize: 16 }}>{ studyName }</li>
        <img src={ add } alt="添加" onClick={() => { alert('添加此项目') }} style={{ position: 'absolute', top: 10, right: -10, cursor: 'pointer' }} />
      </ul>
    )
  }
  return (
    <div className={styles.myApplication}>
      <h2>我的应用 <span>My Application</span></h2>
      <div data-flex="cross:center" style={{ flexWrap: 'wrap' }}>
        { application.map(myApplication) }
        <ul onClick={onOpen}>
          <li style={{ marginTop: 20 }}><img src={ edit } alt=""/></li>
          <li style={{ color: '#202d4c', fontSize: 16 }}>编辑</li>
        </ul>
        <Dialog
          visible={visible}
          footerActions={['cancel', 'ok']}
          isFullScreen={true}
          onOk={onClose}
          onCancel={onClose}
          onClose={onClose}
        >
          <p style={{ width: 948, height: 69, lineHeight: '69px', color: '#fff', fontSize: 24, background: 'linear-gradient(270deg,rgba(41,140,249,1) 0%,rgba(0,108,255,1) 100%)', textAlign: 'center', margin: 0 }}>编辑我的应用</p>
          <div style={{ width: 948, padding: 20, display: 'flex', flexDirection: 'column'  }}>
            <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 25, borderBottom:'1px solid #e8e8e8' }}>
              <h3 style={{ color: '#202d4c', fontSize: 20 }}>我的应用</h3>
              <div style={{ display: 'flex', paddingBottom: 20, flexWrap: 'wrap' }}>
                { editMyApplication.map(editApplication) }
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 25, borderBottom:'1px solid #e8e8e8' }}>
              <h3 style={{ color: '#202d4c', fontSize: 20 }}>全部应用</h3>
              <div style={{ display: 'flex', paddingBottom: 20, flexWrap: 'wrap' }}>
                { editAllApplication.map(allApplication) }
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  )
}
